import {
  SEND_OTP_SUCCESS,
  SEND_OTP_FAILED,
  SEND_OTP_INVALID_HASH,
  SEND_OTP_INVALID_CUSTOMER,
  SEND_OTP_INVALID_DETAILS_EMAIL,
  SEND_OTP_INVALID_DETAILS_MOBILE,
  LOADING_SEND_OTP,
  RESET_SEND_OTP
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  invalidHash: false,
  invalidCustomer: false,
  invalidDetails: false,
  status: "",
  networkError: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_SEND_OTP:
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidHash: false,
        invalidCustomer: false,
        invalidDetails: false,
        status: "",
        networkError: ""
      };
    case SEND_OTP_FAILED:
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidHash: false,
        invalidCustomer: false,
        invalidDetails: false,
        status: "Send OTP failed, please try again",
        networkError: ""
      };

    case SEND_OTP_INVALID_HASH:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidHash: true,
        invalidCustomer: false,
        invalidDetails: false,
        status: "Invalid hash, please try again",
        networkError: ""
      };

    case SEND_OTP_INVALID_CUSTOMER:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidHash: false,
        invalidCustomer: true,
        invalidDetails: false,
        status: "Invalid customer",
        networkError: ""
      };
    case SEND_OTP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidHash: false,
        invalidCustomer: false,
        invalidDetails: false,
        status: "Success",
        networkError: ""
      };

    case SEND_OTP_INVALID_DETAILS_EMAIL:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidHash: false,
        invalidCustomer: false,
        invalidDetails: true,
        status: "Invalid email address provided",
        networkError: ""
      };

    case SEND_OTP_INVALID_DETAILS_MOBILE:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidHash: false,
        invalidCustomer: false,
        invalidDetails: true,
        status: "Invalid mobile number provided",
        networkError: ""
      };

    case RESET_SEND_OTP:
      return (state = initialState);

    default:
      return state;
  }
};
